import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './Store';
import type { SaveStatus } from '../../shared/models/SaveStatus';
import { DocumentSaveStatus } from '../../shared/models/DocumentSaveStatus';
import type { ErrorCode } from 'services/socket/SocketEvents';
import { AcknowledgmentResponseStatus } from 'services/socket/SocketEvents';

export interface SaveStatusState {
  currentSaveStatus: SaveStatus;
}

const initialState: SaveStatusState = {
  currentSaveStatus: { status: DocumentSaveStatus.NOT_SAVED, errCode: '' },
};

const saveStatusSlice = createSlice({
  name: 'saveStatus',
  initialState,
  reducers: {
    setSaveStatus(state, action: PayloadAction<{ status: DocumentSaveStatus; errCode?: string }>) {
      state.currentSaveStatus = { status: action.payload.status, errCode: action.payload.errCode || '' };
    },
    setSaveStatusBasedOnApiResponse(state, action: PayloadAction<{ status: AcknowledgmentResponseStatus; errorCode?: ErrorCode }>) {
      if (action.payload.status === AcknowledgmentResponseStatus.OK) {
        state.currentSaveStatus = { status: DocumentSaveStatus.SAVED, errCode: '' };
      } else if (action.payload.status === AcknowledgmentResponseStatus.FAILURE) {
        state.currentSaveStatus = { status: DocumentSaveStatus.NOT_SAVED, errCode: action.payload.errorCode };
      }
    },
  },
});

export const { setSaveStatus, setSaveStatusBasedOnApiResponse } = saveStatusSlice.actions;

export const selectCurrentSaveStatus = (state: RootState) => state.saveStatus.currentSaveStatus;

export const saveStatus = saveStatusSlice.reducer;
